import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "lib-flexible" ;
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// // 设置Sentry
// Sentry.init({
//   dsn: "https://484aca34f55c452d8a04ef4493ff0987@sentry.huimeimt.com/7",
//   environment: process.env.REACT_APP_ENV,
//   integrations: [new BrowserTracing()],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
